import { State } from 'vuex-simple';
import { BaseModule } from '@/HostApp/store/ApsModules/BaseModule';

export class ContextModule extends BaseModule implements APS.IApsContext {
	constructor() {
		super();
	}

	/**
	 * @State decorator creates a handler 'propName' : {
	 * 		get: () => { return Vuex.store.propName },
	 * 		set: (value) => { Vuex.store.commit(propName, value)}
	 * 	}
	 *
	 * 	to make any value from window.aps reactive, just describe it here with decorator @State()
	 **/

	@State()
	public baseUrl: string = '';

	@State()
	public _locale: string = 'en_EN';

	@State()
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	wizardData?: Common.IMap<any>;

	@State()
	public _css: Array<string> | undefined = undefined;

	@State()
	public _copyright: APS.ICopyrights | undefined = undefined;

	@State()
	public bs: boolean = true;

	@State()
	public googleApiKey: string = '';

	@State()
	public css: Array<string> = [];

	@State()
	public visibleMode: string = '';

	@State()
	public accountType: string = '';

	@State()
	public accountCreatedAt: string = '';

	@State()
	public user = {} as APS.IUserInfo;

	@State()
	public _sessionId: string = '';

	@State()
	public _token: string = '';

	@State()
	public _traceId: string = '';

	@State()
	public subscriptionId: string = '';

	@State()
	public _anonymousUrlPath: string = '';

	@State()
	public _view: APS.IView = {
		id: ''
	} as APS.IView;

	_accountId!: number;
	_accountLevel!: string;
	_brandSuffix!: string;
	_devMode: boolean = false;
	_domainManagement!: { aps: APS.IAps };
	_isLogoLinkNeeded!: boolean;
	_oa!: { _brandId: number; _isImpersonated: boolean };
	_privileges!: Common.IMap<Array<string>>;
	_rtl: boolean = false;
	_sessionCheckTimeout!: number;
	_sessionConfirmationTimeout!: number;
	_supportLinks!: {
		qaLink: string;
		onlineDocLink: string;
		supportContactsLink: string;
		troubleTicketingLink: string;
	};
	_userManagement!: { aps: APS.IAps };
	billingId!: { ordersEnabled: boolean; invoicingEnabled: boolean; aps: APS.IAps };
	bssCurrencySettings!: {
		currencyId: string;
		currencySymbol: string;
		currencyLocation: number;
		currencyPrecision: number;
		showTaxesType: number;
	};
	hiddenViews!: Common.IMap<number>;
	idpPasswordPolicy!: string | null;
	loginUrl!: string;
	nmId!: { aps: APS.IAps };
	params: APS.IParams;
	passwordPolicyMinLength!: string | null;
	passwordQualityLevel!: number;
	src!: string;
	vars!: Common.MapFull | null;
	varsMeta!: Common.MapFull | null;
}

const contextModule = new ContextModule();

export default contextModule;
